import Footer from "components/Footers/Footer";
import Navbar from "components/Navbars/IndexNavbar";
import { useHistory } from "react-router-dom";
import React, { useState, useRef, useEffect } from "react";
import Swal from "sweetalert2";
import BASE_URL from "components/BaseUrl/apiConfig";

const ForgotPassword = () => {
  const history = useHistory();

  const userNameInputRef = useRef(null);

  const [email, setEmail] = useState("");

  const handleGoBack = () => {
    history.goBack();
  };

  useEffect(() => {
    // Focus on the userName input when the component mounts
    userNameInputRef.current.focus();
  }, []);

  const handleSendPassword = async () => {
    // Validate email format before sending
    if (!validateEmail(email)) {
      Swal.fire({
        icon: "error",
        title: "Something went wrong.",
        text: "Please enter a valid email address.",
      });
      return;
    }

    try {
      const response = await fetch(
        `${BASE_URL}/api/Users/ForgotPassword?emailId=${email}`,
        {
          method: "POST",
        }
      );

      if (response.ok) {
        const button = document.getElementById("btnSendEmail");

        Swal.fire({
          icon: "success",
          title: "Success",
          text: "Username and password successfully sent to your email.",
        });

        button.innerHTML = "Resend";
      } else {
        const data = await response.json();
        Swal.fire({
          icon: "error",
          title: "Failed to send email",
          text: data.Msg || "Please try again.",
        });
      }
    } catch (error) {
      console.error("Error sending email:", error);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "An unexpected error occurred. Please try again.",
      });
    }
  };

  // Function to validate email format
  const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  return (
    <>
      <div style={{}}>
        <Navbar />
        <div className="cust-div" style={{ minHeight: "550px" }}>
          <div className="container mx-auto p-4 h-full">
            <div className="flex content-center items-center justify-center h-full">
              <div className="w-full lg:w-6/12 px-4">
                <div className="relative flex flex-col min-w-0 break-words w-full mb-6 shadow-lg rounded-lg bg-white border-0">
                  <div className="rounded-t mb-0 px-6 py-3">
                    <div className="text-center mb-3">
                      <h1 className="text-2xl font-bold">FORGET PASSWORD</h1>
                    </div>

                    {/* <hr className="mt-3 border-b-1 border-blueGray-300" /> */}
                  </div>
                  <div className="flex-auto px-4 lg:px-10 py-3 pt-0">
                    <form>
                      <div className="relative w-full mb-3">
                        <label
                          className="block uppercase text-blueGray-600 text-xs font-bold mb-2"
                          htmlFor="grid-password"
                        >
                          Email Address
                        </label>
                        <input
                          type="email"
                          value={email}
                          maxLength={50}
                          ref={userNameInputRef}
                          onChange={(e) => setEmail(e.target.value)}
                          className="border rounded w-full"
                          placeholder="Enter your Email address"
                        />
                      </div>

                      <div className="text-right mt-6 flex flex-row justify-end">
                        <button
                          onClick={handleGoBack}
                          className="bg-lightBlue-500 text-white active:bg-lightBlue-600 text-xs font-bold uppercase px-3 py-2 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 sm:w-auto ease-linear transition-all duration-150"
                          type="button"
                        >
                          Back to Sign in
                        </button>
                        <button
                          onClick={handleSendPassword}
                          id="btnSendEmail"
                          className="bg-blueGray-800 text-white active:bg-blueGray-600 text-sm font-bold uppercase px-3 py-2 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 sm:w-auto ease-linear transition-all duration-150"
                          type="button"
                        >
                          Send
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    </>
  );
};

export default ForgotPassword;
